import React from 'react';
import { Box, Chip } from '@mui/material';
import colors from '../../../../common/colors';
import type { QuickFilter } from '../../types';

interface QuickFiltersProps {
  selectedFilter: string | null;
  onQuickSelect: (key: string) => void;
  filters: QuickFilter[];
}

const QuickFilters: React.FC<QuickFiltersProps> = ({
  selectedFilter,
  onQuickSelect,
  filters,
}) => {
  return (
    <Box
      display="flex"
      flexWrap="wrap"
      gap={1}
      sx={{
        minWidth: 70,
      }}
    >
      {filters.map((filter) => (
        <Chip
          key={filter.key}
          label={filter.label}
          onClick={() => onQuickSelect(filter.key)}
          variant="filled"
          clickable
          sx={{
            backgroundColor:
              selectedFilter === filter.key ? colors.grey_300 : undefined,
            color: selectedFilter === filter.key ? colors.white : undefined,
            '&:hover': {
              backgroundColor:
                selectedFilter === filter.key ? colors.grey_300 : undefined,
            },
          }}
        />
      ))}
    </Box>
  );
};

export default QuickFilters;
